//
// elements that are safe on the frontend
//

import { DatePicker, TimePicker, DateTimePicker } from './datetime'
import DateRange from './date-range'

document.registerElement('date-picker', DatePicker)
document.registerElement('time-picker', TimePicker)
document.registerElement('datetime-picker', DateTimePicker)
document.registerElement('date-range', { prototype: DateRange })



// WEBPACK FOOTER //
// ./src/elements/frontend.js